import { render, staticRenderFns } from "./AddEditPropertyMeasures.vue?vue&type=template&id=4463fbf8"
import script from "./AddEditPropertyMeasures.vue?vue&type=script&lang=js"
export * from "./AddEditPropertyMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports